import * as BrykConfig from './bryk';
import * as NowFinanceConfig from './nowfinance';
import * as PepperMoneyConfig from './peppermoney';

export {
  BrykConfig,
  NowFinanceConfig,
  PepperMoneyConfig,
};
